<template>
    <form
        @submit.prevent="submit"
        :action="url"
        ref="templateForm"
        method="post"
        class="card space-y-4 flex flex-col"
    >
        <h2 class="heading-2">Upload A Photo</h2>

        <text-input
            label="Name"
            name="name"
            v-model="form.name"
            :error="form.errors.name"
            :placeholder="namePlaceholder"
            help="This is used to describe the photos for search engines. Customers can see this text when they hover over your photo."
        />

        <file-input
            label="File"
            name="file"
            v-model="form.file"
            :error="form.errors.file"
            help="Minimum Dimensions: 1500x1300"
        />

        <loading-button
            :loading="form.processing"
            class="self-end btn btn-green"
        >
            Upload
        </loading-button>
    </form>
</template>

<script setup>
import useForm from '@/functions/useForm'
import { computed, ref } from 'vue'

const props = defineProps({
    url: {
        type: String,
        required: true,
    }
})

const templateForm = ref();
const form = useForm({
    file: null,
    name: '',
})

const year = computed(() => {
    return new Date().getFullYear()
})

const namePlaceholder = computed(() => {
    return `${year.value} - Face From Fair`
})

const submit = () => {
    form.transform(() => new FormData(templateForm.value)).post(props.url, {
        onSuccess: () => window.location.reload()
    })
}
</script>
